// @flow
import * as React from 'react';
import styled from 'styled-components';
import { withRouter } from "react-router-dom";
import _ from "lodash";
import {
	SearchInputWrapper,
	SearchField,
	SearchSubmitButton,
	Select,

} from "../../../../components";
import Search from '../../../../components/Icons/Search';
import { below } from "../../../../assets/css/media";

const SearchWrapper = styled.div`
	width: 25%;
`;

const StyledSearchInputWrapper = styled(SearchInputWrapper)`
	width: 25%;
`;
const SelectWrapper = styled.div`
	display: flex;
	flex-wrap: nowrap;
	/* justify-content: flex-start;
	align-items: center; */
	margin-top: 20px;
	padding-left: 20px;
	padding-right: 20px;

	> div {
		min-width: 140px;
		margin-right: 10px;
	}

	${below.tablet`
		flex-wrap: wrap;
		> div {
			flex-basis: 100%;
			margin-bottom: 10px;
		}
	`};
`;

type Props = {
	rounds: Array<Object>,
	selected: number,
	teams: Object,
	handleRoundChange: Function,
	handleOwnerChange: Function,
	handleTransactionChange: Function,
	handlePlayerChange: Function,
	handleSubmit: Function,
}

type State = {
}
class TransactionHistoryFiltersComponent extends React.Component<Props, State> {
	constructor(props: Props, state: State) {
		super(props, state);

		_.bindAll(this, [
			'handleSwitchChange',
		]);
	}

	state = {
	};

	handleSwitchChange({ currentTarget }: Object) {
		const { name, checked } = currentTarget;
		this.setState({ [name]: checked });
	}

	get renderRoundFilter() {
		const { rounds, handleRoundChange } = this.props;

		const round_options = rounds
			.map( round => <option key={round.id} value={round.id}>Round {round.id}</option>);
		return (
			<SearchWrapper>
				<Select
					name="by_round" is_disabled={false}
					onChange={handleRoundChange}
				>
					<option value="0">
						All Rounds
					</option>
					{round_options}
				</Select>
			</SearchWrapper>
		);
	}

	get renderOwnerFilter() {
		const { teams, handleOwnerChange } = this.props;
		const paired_teams = _.toPairs(teams);
		const owner_options = paired_teams
			.map( team => <option key={team[1].id} value={team[1].id}>{team[1].name}</option>);
		return (
			<SearchWrapper>
				<Select
					is_disabled={false}
					name="by_owner"
					defaultValue={false}
					onChange={handleOwnerChange}
				>
					<option value={0}>
						All Owners
					</option>
					{owner_options}
				</Select>
			</SearchWrapper>
		);
	}

	get renderTransactionFilter() {
		const { handleTransactionChange } = this.props;
		return (
			<SearchWrapper>
				<Select
					name="by_squad" is_disabled={false}
					onChange={handleTransactionChange}
				>
					<option value="">
						All Transactions
					</option>
					<option value="free_agent">
						Free Agents
					</option>
					<option value="trade">
						Trades
					</option>
				</Select>
			</SearchWrapper>
		);
	}

	get renderPlayerFilter() {
		const { handlePlayerChange } = this.props;
		return (
			<StyledSearchInputWrapper>
				<SearchField
					type="text"
					name="search"
					component="input"
					placeholder="Search for a player"
					onChange={handlePlayerChange}
				/>
				<SearchSubmitButton>
					<Search />
				</SearchSubmitButton>
			</StyledSearchInputWrapper>
		);
	}

	render() {
		const { handleSubmit } = this.props;
		return (
			<form onSubmit={handleSubmit}>

				<SelectWrapper>
					{this.renderPlayerFilter}
					{this.renderTransactionFilter}
					{this.renderOwnerFilter}
					{this.renderRoundFilter}
				</SelectWrapper>
			</form>
		);
	}
}

export const TransactionHistoryFilters = withRouter(TransactionHistoryFiltersComponent);

export default withRouter(TransactionHistoryFilters);


// WEBPACK FOOTER //
// ./src/pages/league/transactions/transactionHistory/transactionHistoryFilters.js